import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Theme tokens first, then global resets/typography.
import "./theme/theme.css";
import "./theme/global.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
